import type { EcoCategory } from '@/lib/api'
import { ECO_CATEGORIES, ECO_CATEGORY_LABELS, ECO_CATEGORY_SHORT_LABELS } from '@/lib/ecology'
import { cn } from '@/lib/utils'

/**
 * Категории объектов НВОС в строке справочника (`.cats` макета панели администратора): плашки I–IV и
 * «б/к» (без категории); обязательные для позиции — акцентные, остальные — приглушённые. Для
 * скринридера — текстом списка обязательных категорий.
 */
export function CategoryChips({ categories }: { categories: EcoCategory[] }) {
  const label = categories.length
    ? `Обязателен для категорий: ${categories.map((c) => ECO_CATEGORY_LABELS[c]).join(', ')}`
    : 'Не обязателен ни для одной категории'
  return (
    <span className="inline-flex gap-1" role="img" aria-label={label}>
      {ECO_CATEGORIES.map((c) => {
        const on = categories.includes(c)
        return (
          <span
            key={c}
            aria-hidden
            className={cn(
              'inline-flex h-5 min-w-6 items-center justify-center whitespace-nowrap rounded-7 px-1 text-12 font-semibold',
              on ? 'bg-accent-bg text-accent-txt' : 'bg-gray-bg text-txt-tertiary',
            )}
          >
            {ECO_CATEGORY_SHORT_LABELS[c]}
          </span>
        )
      })}
    </span>
  )
}
